import * as React from "react";
import Footer from "../footer";
import { Plus_Jakarta_Sans } from "next/font/google";
import Header from "../header";

const jakarta = Plus_Jakarta_Sans({
  weight: ["300", "400", "500", "600", "700"],
  style: ["normal"],
  subsets: ["latin"],
  display: "swap",
  variable: "--font-jakarta",
});

const Layout = ({ children }) => {
  return (
    <div
      className={`w-full h-auto block relative bg-white min-h-screen ${jakarta.variable} font-jakarta `}
    >
      <Header />
      <main className={`w-full`}>{children}</main>
      <Footer />
    </div>
  );
};
export default Layout;
